import * as yup from 'yup';

const emailSchema = (): yup.ObjectSchema<{ email: string }> => {
  return yup.object().shape({
    email: yup.string().email().required(),
  });
};

export default emailSchema;
